import React, { useState, useEffect } from "react";
import "./Spinner.css";

function Spinner(props) {
	const [isLoading, setIsLoading] = useState(true);
	// useEffect(() => {
	// 	const timer = setTimeout(() => {
	// 		setIsLoading(false);
	// 	}, 2300);
	// });

	useEffect(() => {
		setIsLoading(props.isLoading);
	}, [props.isLoading]);

	return (
		<div>
			{isLoading ? (
				<div className="loading">
					<div></div>
					<div></div>
				</div>
			) : null}
		</div>
	);
}

export default Spinner;
